import React, { useState } from 'react';
import './VPSMikrotik.css';

const VPSMikrotik = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'شخصی',
      price: '۲۰۰',
      unit: 'هزار تومان / ماه',
      cpu: '1 Core',
      ram: '۲ GB',
      storage: '۲۰ GB SSD',
      features: ['RouterOS', 'مدیریت شبکه', 'VPN', 'پشتیبانی ۲۴/۷'],
      popular: false,
    },
    {
      tier: 'کسب‌وکار',
      price: '۳۵۰',
      unit: 'هزار تومان / ماه',
      cpu: '2 Core',
      ram: '۴ GB',
      storage: '۴۰ GB SSD',
      features: ['RouterOS', 'مدیریت شبکه', 'VPN', 'فایروال', 'پشتیبانی ۲۴/۷'],
      popular: true,
    },
    {
      tier: 'سازمانی',
      price: '۶۰۰',
      unit: 'هزار تومان / ماه',
      cpu: '4 Core',
      ram: '۸ GB',
      storage: '۸۰ GB SSD',
      features: ['RouterOS', 'مدیریت شبکه', 'VPN', 'فایروال', 'NAT', 'پشتیبانی ۲۴/۷'],
      popular: false,
    },
  ];

  const features = [
    {
      icon: '📡',
      title: 'سیستم‌عامل RouterOS میکروتیک',
      desc: 'VPS میکروتیک با سیستم‌عامل RouterOS که یکی از قدرتمندترین و محبوب‌ترین سیستم‌عامل‌های مدیریت شبکه است. امکان مدیریت کامل شبکه، فایروال، VPN و NAT را فراهم می‌کند.',
    },
    {
      icon: '🛡️',
      title: 'امنیت پیشرفته شبکه',
      desc: 'میکروتیک با امکانات امنیتی پیشرفته مانند فایروال، محافظت در برابر حملات DDoS و سیستم‌های تشخیص نفوذ، امنیت شبکه شما را تضمین می‌کند.',
    },
    {
      icon: '🔗',
      title: 'مدیریت VPN و اتصالات امن',
      desc: 'امکان راه‌اندازی VPN با پروتکل‌های مختلف مانند PPTP، L2TP، SSTP و OpenVPN برای ارتباط امن بین دفاتر و کاربران راه‌دور.',
    },
    {
      icon: '⚡',
      title: 'عملکرد بالا و پایداری عالی',
      desc: 'VPS میکروتیک با بهره‌گیری از منابع اختصاصی، عملکرد بالا و پایداری عالی را برای مدیریت شبکه شما فراهم می‌کند.',
    },
  ];

  const faqs = [
    {
      q: 'VPS میکروتیک برای چه کاربردی مناسب است؟',
      a: 'VPS میکروتیک برای مدیریت شبکه، راه‌اندازی VPN، فایروال، NAT، مدیریت پهنای باند، مسیریابی و به طور کلی هرگونه نیاز شبکه‌ای مناسب است. شرکت‌های ارائه‌دهنده خدمات اینترنت (ISP)، شرکت‌های شبکه، سازمان‌ها و افرادی که نیاز به مدیریت شبکه پیشرفته دارند، از VPS میکروتیک استفاده می‌کنند.',
    },
    {
      q: 'آیا VPS میکروتیک برای راه‌اندازی VPN مناسب است؟',
      a: 'بله، VPS میکروتیک با پشتیبانی از پروتکل‌های مختلف VPN مانند PPTP، L2TP، SSTP و OpenVPN، گزینه‌ای عالی برای راه‌اندازی VPN شخصی، سازمانی یا فروش VPN به مشتریان است. شما می‌توانید با استفاده از میکروتیک، اتصالات امن و رمزنگاری شده برای کاربران خود ایجاد کنید.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>VPS میکروتیک | خرید سرور مجازی میکروتیک با بهترین قیمت | افرسل</h1>
        <p>خرید VPS میکروتیک با سیستم‌عامل RouterOS، مدیریت شبکه و پشتیبانی ۲۴ ساعته. سرور مجازی میکروتیک مناسب برای مدیریت شبکه، VPN، فایروال و ISPها.</p>
        <meta name="description" content="خرید VPS میکروتیک با بهترین قیمت از افرسل. سرور مجازی میکروتیک با RouterOS، مدیریت شبکه، VPN، فایروال و پشتیبانی ۲۴/۷." />
      </div>

      <section className="vps-mikrotik-hero">
        <div className="vps-mikrotik-hero-bg"></div>
        <div className="wrap">
          <div className="vps-mikrotik-hero-content">
            <div className="vps-mikrotik-badge">
              <span className="pulse-dot"></span>
              📡 VPS میکروتیک
            </div>
            <h1 className="vps-mikrotik-hero-title">
              سرور مجازی <em>میکروتیک</em>
            </h1>
            <p className="vps-mikrotik-hero-desc">
              VPS میکروتیک با سیستم‌عامل RouterOS و امکانات کامل مدیریت شبکه.
              مناسب برای مدیریت شبکه، VPN، فایروال، NAT و ارائه‌دهندگان خدمات اینترنت.
            </p>
            <div className="vps-mikrotik-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">RouterOS</span>
                <span className="stat-label">سیستم‌عامل</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vps-mikrotik-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های VPS میکروتیک</span>
            <h2 className="sec-h">پلن <em>مناسب</em> نیاز شبکه خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع VPS میکروتیک با قیمت‌های رقابتی و منابع کافی برای مدیریت شبکه.</p>
          </div>
          <div className="vps-mikrotik-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`vps-mikrotik-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="vps-mikrotik-popular-badge">پرفروش‌ترین</span>}
                <div className="vps-mikrotik-plan-tier">{plan.tier}</div>
                <div className="vps-mikrotik-plan-price">
                  <span className="vps-mikrotik-plan-num">{plan.price}</span>
                  <span className="vps-mikrotik-plan-unit">{plan.unit}</span>
                </div>
                <div className="vps-mikrotik-plan-specs">
                  <div><span>🖥️</span> {plan.cpu}</div>
                  <div><span>💾</span> {plan.ram}</div>
                  <div><span>📀</span> {plan.storage}</div>
                </div>
                <ul className="vps-mikrotik-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="vps-mikrotik-order-btn" onClick={() => scrollTo('contact')}>سفارش دهید</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-mikrotik-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای VPS میکروتیک</span>
            <h2 className="sec-h">چرا <em>VPS میکروتیک</em> با افرسل؟</h2>
            <p className="sec-p">VPS میکروتیک با بهترین امکانات برای مدیریت شبکه و ارائه خدمات ISP.</p>
          </div>
          <div className="vps-mikrotik-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="vps-mikrotik-feature-card">
                <span className="vps-mikrotik-feature-icon">{feature.icon}</span>
                <h3 className="vps-mikrotik-feature-title">{feature.title}</h3>
                <p className="vps-mikrotik-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-mikrotik-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
          </div>
          <div className="vps-mikrotik-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="vps-mikrotik-faq-item">
                <div className="vps-mikrotik-faq-q">{faq.q}</div>
                <div className="vps-mikrotik-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vps-mikrotik-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              VPS <em>میکروتیک</em> را همین حالا خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید VPS میکروتیک، شبکه خود را با بهترین کیفیت مدیریت کنید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>خرید VPS</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VPSMikrotik;
